export default __webpack_public_path__ + "src/images/packages/simbambili-lodge/e9978b6afe66a71ba82fea4079f276ff-2.jpg";